//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Checkbox from '../../../../components/checkbox';
import Field from '../field';
import SecondaryCheckboxIcon from '../../../../iconsPublicSite/checkbox/secondary';
import WhiteCheckboxIcon from '../../../../iconsPublicSite/checkbox/white';
import PrimaryCheckboxIcon from '../../../../iconsPublicSite/checkbox/primary';
import PrimaryCheckedCheckboxIcon from '../../../../iconsPublicSite/checkbox/primaryChecked';

export default ({
  components: {
    Field,
    SecondaryCheckboxIcon,
    WhiteCheckboxIcon,
    PrimaryCheckboxIcon,
    PrimaryCheckedCheckboxIcon,
  },
  extends: Checkbox,
  props: {
    theme: {
      type: String,
      validator: (value) => {
        return ['secondary', 'gray', 'white', 'primary'].includes(value);
      },
      default: 'secondary',
    },
    error: Boolean,
    errorMessage: {
      type: String,
      default: null,
    },
    errorMessageColor: {
      validator: (value) => {
        return ['white', 'red', 'pink'].includes(value);
      },
      default: 'red',
    },
    size: {
      type: String,
      validator: (value) => {
        return ['s', 'm', 'l'].includes(value);
      },
      default: 'm',
    },
  },
});
